// biome-ignore lint/suspicious/noExplicitAny: The loader func can define its own args. We don't care what they are. "any" is a better fit than "unknown"
type LoaderFunction<T, Args extends any[]> = (...args: Args) => Promise<T>;

/** dependencyLoader
 * A utility to create a dependency loader that ensures a function is only called
 * once, and returns the cached result on subsequent calls.
 * We use it to load dependencies like prebid.js, apsTag, etc. and to prevent
 * duplicate calls to any side-effects they might have upon import.
 * We also use it to encapsulate first-time-only setup like exposing a global,
 * e.g. pbjs.
 */
// biome-ignore lint/suspicious/noExplicitAny: see above
export const createDependencyLoader = <T, Args extends any[] = []>(
	loader: LoaderFunction<T, Args>,
) => {
	let promise: Promise<T> | null = null;

	const ensure = (...args: Args): Promise<T> => {
		if (!promise) {
			promise = loader(...args);
		}
		return promise;
	};

	const reset = () => {
		promise = null;
	};

	return { ensure, reset };
};
